var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['ot-base-button', _vm.buttonType, _vm.className, _vm.size],style:({ width: _vm.width ? _vm.width : '' }),attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }